import type { PopupT } from "../../../store/slices/popupSlice";
import getAdIdsFromVersions from "./getAdIdsFromVersions";
import getAdIdFromFileName from "./getAdidFromFileName";
import removeMXFFilesIfBroadcaster from "./removeMXFFilesIfBroadcaster";
import { P } from "../../Text/Text";
import checkFileFormat from "./checkFileFormat";
import FileUploadError from "../../../popups/FileUploadError";


const checkAddedFiles = (
  files: File[],
  createPopup: (config: Omit<PopupT, "id">) => void,
  removePopup: () => void,
  uploader: any,
  versions: any,
  user: any,
  project: any,
  t: any,
  validName?: string,
) => {
  const rejectedFiles = [];

  let showAlert = false;

  // Prevent adding files with names that are already queued (excluding canceled ones)
  const existingActiveNames = new Set(
    (uploader?.getUploads?.() || [])
      .filter((u: any) => u?.status !== "canceled")
      .map((u: any) => u?.name)
  );

  const adIds = getAdIdsFromVersions(versions);
  removeMXFFilesIfBroadcaster(user, project, files, uploader);




  files.forEach((file) => {
    const targetName = validName || file.name;
    const uploadedFileAdId = getAdIdFromFileName(file);

    const isUploadAllowed = (versions.find((version) => targetName === version?.AdId + "." + version?.fileFormat?.toLowerCase?.()) || { UploadAllowed: true })?.UploadAllowed;

    if (existingActiveNames.has(targetName) || !isUploadAllowed) {
      rejectedFiles.push(file.name);
      createPopup(
        FileUploadError(
          false,
          removePopup,
          `You have reached the maximum number of versions allowed for this delivery. Please remove one or more versions to continue.`
        )
      );
      return false;
    }

    if (!adIds.includes(uploadedFileAdId) && !validName) {
      rejectedFiles.push(file.name);
      showAlert = true;
    } else {
      const fileAdded = new CustomEvent("file-added", {
        detail: {
          adId: uploadedFileAdId,
        },
      });

      const validAdId = validName?.split(".")?.[0];

      document.dispatchEvent(fileAdded);
      const allowedVersionFileExtension = versions
        ?.find(
          (version) =>
            version.AdId === uploadedFileAdId || version.AdId === validAdId
        )
        ?.fileFormat?.toLocaleLowerCase();

      const wrongExtension = checkFileFormat(
        user.role,
        project.StatusName,
        allowedVersionFileExtension,
        file
      );

      if (
        wrongExtension ||
        (file.name.includes(".") &&
          !file.name.toLowerCase().includes("mp4") &&
          !file.name.toLowerCase().includes("mxf"))
      ) {
        rejectedFiles.push(file.name);
        createPopup(
          FileUploadError(
            false,
            removePopup,
            wrongExtension &&
            `File ${uploadedFileAdId} must be an ${allowedVersionFileExtension?.toUpperCase()} file format.`,
            wrongExtension && (
              <P>{t`File ${uploadedFileAdId} must be an ${allowedVersionFileExtension?.toUpperCase()} file format.`}</P>
            )
          )
        );
      }
    }
  });
  if (showAlert) {
    createPopup(FileUploadError(false, removePopup, false));
  }

  files
    .filter((file) => !rejectedFiles.includes(file.name))
    .forEach((data: File) => {
      // const validName = e.detail.fileName + "." + data.name.split(".")[1];
      // setReplacedNames((prev) => ({ ...prev, [e.detail.fileName]: data.name }));

      if (uploader) {
        uploader.addFiles({
          source: "file input",
          name: validName || data.name,
          type: data.type,
          blob: data,
        } as any);
      }
    });

  return true;
};

export default checkAddedFiles;
